<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/equipment/equipment-list' }">设备管理</el-breadcrumb-item>
          <el-breadcrumb-item >设备注册</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="equip-add">
      <dv-border-box-12 style="padding: 5px 0px;">
        <div style="padding:1px 6px 0px 6px">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">设备注册</div>
            </div>
          </div>
           <el-form
            :model="form"
            label-width="100px"
            class="add-form"
            :rules="rules"
            ref="form">
            <el-form-item label="设备UDI" prop="equip_udi">
                <div style="display: flex;flex-direction: row;">
                  <el-input id="equip_udi" v-model="form.equip_udi" placeholder="UDI包含数字和字母,共41位" style="width: 500px;" oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')">
                    <!-- oninput="value=value.replace(/[^\d]/g,'')" -->
                    <!-- 手动输入或点击右侧选择图片自动识别,UDI为41位纯数字 -->
                    <!-- 手动输入或点击右侧选择图片自动识别, -->
                  </el-input>
                  <!-- <input style="margin-top: 10px;margin-left: 5px;" id="pictureD_file" accept="image/*" type="file" capture="camera" name="pictureD_file" @change="handleFiles($event)" /> -->
                </div>
            </el-form-item>
            <el-form-item label="注册日期" prop="registerDate" style="margin-top: 40px;">
               <el-date-picker
                id="registerDate"
                    v-model="form.registerDate"
                    type="date"
                    placeholder="点击选择注册日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    >
                </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="使用单位" prop="hospital_name">
              <el-input v-model="form.hospital_name" placeholder="请输入使用单位名称" style="width: 50%;"></el-input>
            </el-form-item>
            <el-form-item label="所在地区" prop="provinceCode">
              <el-cascader
              ref="cascader"
              placeholder="请选择使用单位所在地区"
              :options="placeList"
              :props="{ value: 'id',label: 'name'}"
              @change="getSelectedList"
              clearable
              style="width: 50%;"
              ></el-cascader>
            </el-form-item> -->
            <el-form-item>
              <el-button class="action-button" @click="resetForm('form')">重置</el-button>
              <el-button type="primary" class="action-button" @click="submitForm('form')">立即保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </dv-border-box-12>
    </div>
  </div>
</template>

<script>
  import {areaSingleConversionUtil} from '../../../utils/povince_handle.js'
  // import Quagga from 'quagga'

  export default {
    data() {
      return {
        form: {
          equip_udi: '',
          registerDate:'',
          // hospital_name: '',
          // provinceCode:'',
          // provinceName:'',
          // cityCode:'',
          // cityName:''
        },
        rules: {
          equip_udi: [{ required: true, message: '请填写设备UDI', trigger: 'blur' },{min: 41,max:41,message:'请输入41位数字和字母组合'}],
          registerDate: [{ required: true, message: '请选择注册日期', trigger: 'blur' }],
        },
        placeList:[]
      }
    },
    methods: {
      getSelectedList(val){
        this.form.provinceCode = val[0];
        this.form.cityCode = val[0] + val[1]

        areaSingleConversionUtil.codeToName(this.form)

      },
      //识别设备UDI二维码
      // handleFiles($event){
      //   const files = $event.target.files[0]
      //   let that = this
      //   if(files){
      //     const reader = new FileReader()
      //     reader.readAsDataURL(files)
      //     reader.onloadend = function(){
      //       const img = new Image()
      //       img.src = reader.result
      //       that.initSrc(img.src);
      //     }
      //   }
      // },

      // initSrc(src){
      //   let that = this
      //   const config = {
      //     locator: {
      //       patchSize: 'medium',
      //       halfSample: true
      //     },
      //     numOfWorkers:(navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 4),
      //     decoder : {
      //       readers: ['code_128_reader','ean_reader','ean_8_reader','codabar_reader','code_39_reader','code_39_vin_reader','upc_reader','upc_e_reader','i2of5_reader'],
      //     },
      //     locate: true,
      //     src:src
      //   }

      //   Quagga.decodeSingle(config,function(result) {
      //     if(!result){
      //       that.$message({
      //         message:'未识别到条形码',
      //         type:'warning'
      //       })
      //       return false;
      //     }else if(result.codeResult){
      //       ////识别结果
      //         const code = result.codeResult.code;
      //         // that.form.equip_udi = code;
      //         if(code.length == 41){
      //           that.form.equip_udi = code;
      //         }else{
      //           that.$message({
      //             message:'UDI不合规，请确认后再提交',
      //             type:'warning'
      //           })
      //           that.form.equip_udi = code;
      //         }
      //     }else{
      //       that.$message({
      //         message:'未识别到条形码',
      //         type:'warning'
      //       })
      //     }
      //     Quagga.stop()
      //   })
      // },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addOneEquip();
          } else {
            return false;
          }
        });
      },

      addOneEquip(){
        var udi = ''
        if(this.form.equip_udi.length === 41){
          var code = this.form.equip_udi;
          const part1 = '(' + code.substring(0,2) + ')' + code.substring(2,16)
          const part2 = '(' + code.substring(16,18) + ')' + code.substring(18,24)
          const part3 = '(' + code.substring(24,26) + ')' + code.substring(26,36)
          const part4 = '(' + code.substring(36,38) + ')' + code.substring(38,41)
          udi = part1 + part2 + part3 + part4
        }else {
          this.$message({
            message:'UDI不合规，请确认后再提交',
            type:'warning'
          })
          // udi = this.form.equip_udi;
          return ;
        }
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/add';
        const data = {
          'udi':udi,
          'registerDate':this.form.registerDate
          // "hospitalName":this.form.hospital_name,
          // "provinceCode":this.form.provinceCode,
          // "cityCode":this.form.cityCode
        };

        this.$http({
          method:'POST',
          url:url,
          data:data,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                type:'success',
                message:'注册成功'
              })
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    mounted() {
      this.placeList = this.$place.province;
    },
    created() {
    }
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }

    .equip-add{
      width: 100%;
      float: left;

      .add-form{
        padding: 25px 5px;

          .distinguish{
            display: flex;
            flex-direction: row;
          }

          .action-button{
            width: 120px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
          }

          .action-button{
            width: 120px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
          }

          .warning-handle{
            background-color: #B26100;
            border: 1px solid rgba(255, 132, 0, 0.84);
            // border-radius: 20px;
            color: #fff;
            margin-left: 5px;
          }

          .error{
          }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/manage/equipment/equipment-add.vue